import { isString } from "lodash";

import i18n from "src/locales/i18n";

import { BusinessErrorCodes } from "src/types/business-errors";


export const getUpdateFieldConfigErrorMessage = (e: any) => {

    if (e?.status === 403) {
        return i18n.t('exceptions.unauthorized');
    }

    if (isString(e?.data?.error_code)) {
        if (e?.data.error_code === BusinessErrorCodes.MaxCustomFieldsReached) {
            return i18n.t('admin-organization.settings.custom_field_settings.api.update.max_fields_reached');
        }

        if (e?.data.error_code === BusinessErrorCodes.OptionsRequiredForSelectType) {
            return i18n.t('admin-organization.settings.custom_field_settings.api.update.options_required_for_select_type');
        }
    }

    return i18n.t('admin-organization.settings.custom_field_settings.api.update.default_error');
};